<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <span
        ><a-icon type="wallet" class="margin-right-small" />UM Closed by Upload BA</span
      >
      <!-- <a-button @click="handleReload" size="small" icon="reload"></a-button> -->
    </div>
    <a-spin :spinning="loading.page" tip="Loading...">
      <div class="wrapper-body">
        <a-card>
          <a-card>
            <div style="display: none">
              <a-select
                placeholder="Ex: Need Process ... "
                v-model="tabs.active"
                :disabled="true"
                @change="moreSearch"
                class="width-full"
                initialValue="process"
                allowClear
              >
                <a-select-option value="release">release</a-select-option>
                <a-select-option value="needprocess">needprocess</a-select-option>
              </a-select>
            </div>
            <a-row :gutter="16">
              <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                <a-input-search v-model="search" placeholder="Quick Search" />
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                <a-date-picker
                  placeholder="Transaction Date"
                  v-model="transactionDt"
                  :format="getDefaultDateFormat"
                  allowClear
                />
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                <a-select
                  v-model="typetransaction"
                  class="width-full"
                  initialValue="all"
                >
                  <a-select-option value="all">All Type</a-select-option>
                  <a-select-option value="UMPP">UMPP</a-select-option>
                  <a-select-option value="UMPD">UMPD</a-select-option>
                </a-select>
              </a-col>
            </a-row>
          </a-card>
        </a-card>
        <div class="bordered">
          <a-config-provider :locale="getLocalConfigProvider()">
          <!-- <a-tabs
            class="custom-tabs"
            :activeKey="tabs.active"
            @change="handleTab"
          >
            <a-tab-pane key="needprocess">
              <template slot="tab">
                <span>Need Process</span>&nbsp;
                <a-badge
                  class="m-badge m-badge-small"
                  :count="needProcess.length"
                  :numberStyle="{ backgroundColor: 'red' }"
                  v-if="needProcess.length > 0"
                >
                </a-badge>
              </template> -->
              <a-table
                :rowKey="(record, index) => {return index;}"
                key="id_financing_dtl"
                size="small"
                bordered
                :scroll="{ x: 760 }"
                :columns="columns.needProcess"
                :dataSource="needProcess"
                :loading="tabs.loading"
              >
                <template slot="nomor" slot-scope="text, data, index">
                  <span>{{ index + 1 }}</span>
                </template>
                <template slot="no" slot-scope="text, data, index">
                  <a @click="handleLink(data.type,data.id_um)"
                    >{{ data.no }}</a
                  >
                </template>
                <template slot="value" slot-scope="text, data">
                  <span>{{
                    formatCurrency(data.currency, data.value)
                  }}</span>
                </template>
                <template slot="remaining" slot-scope="text, data">
                  <span>{{
                    formatCurrency(data.currency, data.remaining)
                  }}</span>
                </template>
                <template slot="aksi" slot-scope="text, data ,index">
                  <a-checkbox
                    :checked="data.cek=='1' ? true : false"
                    :key="index"
                    @change="changeActioncheck(data)"
                  />
                  <!-- <a-button-group>
                    <a-button
                      type="primary"
                      @click="handlemodal1(data)"
                      >Process Close</a-button
                    >
                  </a-button-group> -->
                </template>
              </a-table>
  
              <div class="ant-card-body m-display-flex space-end">
                <!-- <a-button-group>
                  <a-button
                    type="primary"
                    @click="handlemodal1()"
                    >Generate</a-button
                  >
                </a-button-group> -->
              </div>
            <!-- </a-tab-pane> -->

            <!-- <a-tab-pane key="release">
              <template slot="tab">
                <span>UM Closed by Authorized</span>&nbsp;
                <a-badge
                  class="m-badge m-badge-small"
                  :count="release.length"
                  :numberStyle="{ backgroundColor: 'red' }"
                  v-if="release.length > 0"
                >
                </a-badge>
              </template>
              <a-table
                :rowKey="(record, index) => {return index;}"
                size="small"
                bordered
                :scroll="{ x: 900 }"
                :columns="columns.release"
                :dataSource="release"
                :loading="tabs.loading"
              >
                <template slot="nomor" slot-scope="text, data, index">
                  <span>{{ index + 1 }}</span>
                </template>
                <template slot="no" slot-scope="text, data, index">
                  <span>{{ data.no }}</span>
                </template>
                <template slot="createBy" slot-scope="text, data">
                  <h4 class="margin-remove">{{ data.tlc_create }}</h4>
                  <span>{{
                    moment(data.create_dt).format(getDefaultDateFormat)
                  }}</span>
                  /
                  <span>{{ data.tlc ? data.tlc : "-" }}</span>
                </template>
                <template slot="value" slot-scope="text, data">
                  <span>{{ formatCurrency(data.currency, data.value) }}</span>
                </template>
                <template slot="no_bkk" slot-scope="text">
                  <span>{{ text ? text : "-" }}</span>
                </template>
                <template slot="createdby" slot-scope="text, data">
                    <span>TLC: {{data.tlc_create}}</span><br/>
                    <span>Date: {{moment(data.date).format('DD-MM-YYYY HH:mm:ss')}}</span>
                </template>
                <template slot="status" slot-scope="text, data">
                    <Status :status="data.status" />
                </template>
                <template slot="manifest" slot-scope="text, data">
                    <a-button type="primary" @click="handleManifestRef(data)">Manifest</a-button>
                </template>
              </a-table>
            </a-tab-pane> -->
          </a-tabs>
          </a-config-provider>
        </div>
      </div>
    </a-spin>
    <!-- <Modal :modalVis="modal1" :DataClosing="DataClosing"/> -->
  </div>
</template>

<script>
import { mapGetters, } from "vuex";
import axios from "axios";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import shortingArray from "@/mixins/MultishortArray";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import Modal from "./Modal.vue";
import _ from "lodash";

export default {
  name: "closing-um-ba-index",
  components: {Modal},
  mixins: [CurrencyFormat, HandleRoute, shortingArray,GlobalMethod],
  data() {
    const columns = {
      release: [
        {
          title: "#",
          key: "nomor",
          scopedSlots: { customRender: "nomor" },
          align: "right",
          width: 20,
        },
        {
          title: "No",
          key: "no",
          width: 75,
          scopedSlots: { customRender: "no" },
        },
        // {
        //   title: "Date",
        //   key: "date",
        //   dataIndex: "date",
        //   align: "center",
        //   width: 150,
        // },
        {
          title: "Description",
          key: "description",
          dataIndex: "description",
          width: 100,
        },
        {
          title: "Value",
          key: "value",
          scopedSlots: { customRender: "value" },
          align: "right",
          width: 55,
        },
        {
          title: "Created By",
          scopedSlots: { customRender: "createdby" },
          width: 55,
        },
        {
          title: "Status",
          key: "status",
          scopedSlots: { customRender: "status" },
          align: "center",
          width: 50,
        },
        {
          title: "Action",
          key: "action",
          align: "center",
          scopedSlots: { customRender: "manifest" },
          width: 45,
        },
        
        
      ],
      needProcess: [
        {
          title: "#",
          key: "nomor",
          scopedSlots: { customRender: "nomor" },
          align: "right",
          width: 40,
        },
        {
          title: "No",
          key: "no",
          width: 190,
          scopedSlots: { customRender: "no" },
        },
        {
          title: "Date",
          key: "date",
          dataIndex: "date",
          align: "center",
          width: 80,
        },
        {
          title: "Description",
          key: "description",
          dataIndex: "description",
          width: 200,
        },
        {
          title: "Type",
          key: "type",
          dataIndex: "type",
          align: "center",
          width: 75,
        },
        {
          title: "TLC",
          key: "tlc",
          dataIndex: "tlc",
          align: "center",
          width: 75,
        },
        {
          title: "Value",
          key: "value",
          scopedSlots: { customRender: "value" },
          align: "right",
          width: 100,
        },
        // {
        //   title: "Action",
        //   scopedSlots: { customRender: "aksi" },
        //   fixed: 'right',
        //   align: "center",
        //   width: 60,
        // },
      ],
    };
    return {
      columns,
      tabs: {
        active: "needprocess",
        loading: false,
      },
      release: [],
      needProcess: [],
      release_origin: [],
      needProcess_origin: [],
      search: undefined,
      typetransaction: "all",
      transactionDt: null,
      buktiTransfer: [],
      advancedsearch: "display:none",
      needProcessSuplier: [],
      DataClosing: {
        list: {},
        document: {},
        note: "",
        value: 0,
        valuelbl: "",
        doc_name:"",
        attachment:{},
        pushFile:{},
        doc_attachment: {},
        loadingadd:false,
      },
      modal1: false,
      indexData: 0,
      loadingmodalcloseUM: false,
      postData: new FormData(),
      DataClosingRules:{
        note: {
          required: false,
          message: "please input Note!",
          trigger: "blur",
        },
      },
      doc_attachment: {},
      loading: {
        page: false,
      }
    };
  },
  beforeCreate() {
    this.modalForm = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    moreSearch: function () {
      let tempData = [];
      if (this.tabs.active == "needprocess") {
        tempData = this.needProcess_origin;
      } else {
        tempData = this.release_origin;
      }

      if (tempData.length > 0) {
        if (this.tabs.active == "release") {
          if (this.search) {
            tempData = tempData.filter(
              (obj) =>
                (obj.no &&
                  obj.no
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.description &&
                  obj.description
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.no &&
                  obj.no
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.date &&
                  this.moment(obj.date)
                    .format(this.getDefaultDateFormat)
                    .toString()
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.tlc &&
                  obj.tlc
                    .toString()
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.value &&
                  this.formatCurrency("IDR", obj.value)
                    .toString()
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.type &&
                  obj.type
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.close_by &&
                  obj.close_by
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.close_dt &&
                  this.moment(obj.close_dt)
                    .format(this.getDefaultDateFormat)
                    .toString()
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0)
            );
          }

          if (this.typetransaction && this.typetransaction !== "all") {
            tempData = tempData.filter(
              (obj) =>
                obj.type && obj.type == this.typetransaction
            );
          }

          if (this.transactionDt) {
            let startDt = moment(this.transactionDt).format(
              this.getDefaultDateFormat
            );
            tempData = tempData.filter((obj) => moment(obj.date).format(
              this.getDefaultDateFormat
            ) == startDt);
          }

          this.intoList(this.tabs.active, tempData);
        } else if (this.tabs.active == "needprocess") {
          if (this.search) {
            tempData = tempData.filter(
              (obj) =>
                (obj.no &&
                  obj.no
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.description &&
                  obj.description
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.no &&
                  obj.no
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.date &&
                  this.moment(obj.date)
                    .format(this.getDefaultDateFormat)
                    .toString()
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.tlc &&
                  obj.tlc
                    .toString()
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.value &&
                  this.formatCurrency("IDR", obj.value)
                    .toString()
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.type &&
                  obj.type
                    .toLowerCase()
                    .indexOf(this.search.toLowerCase()) >= 0)
            );
          }

          if (this.typetransaction && this.typetransaction !== "all") {
            tempData = tempData.filter(
              (obj) =>
                obj.type && obj.type == this.typetransaction
            );
          }

          if (this.transactionDt) {
            let startDt = moment(this.transactionDt).format(
              this.getDefaultDateFormat
            );
            console.log(startDt)
            tempData = tempData.filter((obj) => obj.date == startDt);
          }
          this.intoList(this.tabs.active, tempData);
        }
      }

      this.intoList(this.tabs.active, tempData);
      if (
        !this.tabs.active &&
        !this.search &&
        !this.transactionDt &&
        !this.typetransaction
      ) {
        this.intoList(this.tabs.active, tempData);
      }
      return true;
    },
  },
  mounted() {
    Event.$on("handleClose", this.closetrans);
    Event.$on("handlemodalClose", this.handlemodalClose);
    Event.$on("handlesuccessClose", this.handlesuccessClose);
    this.fetch();
  },
  beforeDestroy() {
    Event.$off("handleClose", this.closetrans);
    Event.$off("handlemodalClose", this.handlemodalClose);
    Event.$off("handlesuccessClose", this.handlesuccessClose);
  },
  methods: {
    moment,
    fetch() {
      this.loading.page = true;
      this.asyncAxiosGet(
        "um_close/um_upload_ba",
        this.getAuth,
        {
          tlc: this.getAuth.username
        }
      ).then((res) => {
          //this.release = res.data.um_closed;
          this.needProcess = res.need_process;

          //this.release_origin = res.data.um_closed;
          this.needProcess_origin = res.need_process;

          // this.tabs.loading = false;
          this.loading.page = false;
      }).catch((err) => {
        let responses = Object.assign({}, err);
        console.log(responses);
        this.displayMessageValue("error", responses);
        this.loading.page = false;
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    resetSearch() {
      this.search = undefined;
      this.transactionDt = undefined;
      this.typetransaction = "all";
    },
    intoList(type, value) {
      if (type == "release") {
        this.release = value;
      } else {
        this.needProcess = value;
      }
    },
    handleReload() {
      this.tabs.loading = true;
      this.fetch();
      this.resetSearch();
    },
    handleTab(val) {
      this.tabs.active = val;
      this.resetSearch();
    },
    handleCreate(item) {
      console.log("ini di create");
      console.log(item);

      // this.$router.push({
      //   name: "account-pay-create",
      //   params: { id: item.id, type: item.jenis_id },
      // });
    },
    handleRelease(item) {
      this.$store
        .dispatch("releaseQueue", {
          auth: this.getAuth,
          id_ap: item.id_account_pay,
        })
        .then((res) => {
          this.$router.go();
          this.displayMessage("success-release");
        });
    },
    handleManifestRef(item) {
      const data = {
        rest_api: "close_um",
        id_manifest: item.id,
        tlc: this.getAuth.username,
        user_pembuat: item.tlc_create,
      };

      this.handleView(data,true);
    },
    handleManifest(item) {
        this.$router.push({
          name: "account-pay-manifest",
          params: { id: item.id_account_pay },
        });
    },
    handleDocument(item) {
      this.$store
        .dispatch("getBuktiPS", {
          auth: this.getAuth,
          id: item.id_payment_schedule,
        })
        .then((res) => {
          this.buktiTransfer = res.data.bukti_tf;
        });
    },
    handleDownload(item) {
      window.open(this.$serviceUrl + item.path, "_blank");
    },
    handleClose() {
      this.modal1 = false;
      this.DataClosing.note='';
    },
    handleshowMore() {
      if (this.advancedsearch == "display:none") {
        this.advancedsearch = "display:block";
      } else {
        this.advancedsearch = "display:none";
      }
    },
    handleRevisiAndClose(item) {
      const that = this;
      let title = "";
      let messageSukses = "";
      title = "Are you sure to revise this data";
      messageSukses = "Successfully revise data";

      this.$confirm({
        title: title,
        content: "Batal / OK?",
        onOk() {
          let promise = new Promise((resolve, reject) => {
            let data = {
              tlc: that.getAuth.username,
              aksi: item.button_aksi,
              id: item.id,
              jenis_transaksi: item.jenis_transaksi,
            };

            // try {
            //   resolve(data);
            // } catch {
            //   reject("error data");
            // }

            axios({
              method: "post",
              url: that.$serviceUrl + "account_pay/aksi_account_pay",
              data: data,
              auth: {
                username: that.getAuth.username,
                password: that.getAuth.password,
              },
              headers: {
                "Content-Type": "application/json",
                "X-API-KEY": that.getAuth.apikey,
              },
            })
              .then(({ data, status }) => {
                resolve(data);
              })
              .catch((err) => {
                reject(err);
              });
          }).catch(() => console.log("Oops errors!"));
          promise
            .then((value) => {
              that.displayMessageValue("success-other", messageSukses);
              that.handleReload();
            })
            .then((err) => {
              if (err) {
                let responses = Object.assign({}, err.response.data);
                that.displayMessageValue("error-other", responses.message);
              }
            });
          return promise;
        },
        onCancel() {},
      });
    },
    handleLinkPaymentSchedule(id) {
      this.$router.push({
        name: "PaymentScheduleManifestKeu",
        params: { id: id },
      });
    },
    handleLinkFinancing(id) {
      this.$router.push({ name: "financing-manifest", params: { id: id } });
    },
    handlemodal1() {
      this.DataClosing.list = _.filter(this.needProcess_origin, (item) => item.cek=='1');

      if (this.DataClosing.list.length==0){
        this.displayMessageValue("error-other", "Selected data is empty!");
        return;
      }
      let val = 0;
      _.forEach(this.DataClosing.list, function(value) {
        if(value.currency=="IDR"){
          val += Number(value.value);
        }else{
          val += Number(value.value)*Number(value.kurs);
        }
      });
      this.DataClosing.value= val.toFixed(2);
      this.DataClosing.note="";
      this.modal1 = true;
    },
    handleCancel() {
      this.modal1 = false;
    },
    handleModalClosing() {
      //this.confirmMessageValue("confirm-save", null, null);
      const that = this;
      this.$refs.closingForm.validate((valid) => {
        if (!valid) {
          this.displayMessageValue(
            "basic-error",
            "Please complete Details Form"
          );
          return;
        }


        let data = new FormData(); 
        data.append("tlc", this.getAuth.username);
        data.append("note", this.DataClosing.note);
        data.append("id_um", this.DataClosing.id_um);
        
        that.loadingmodalcloseUM = true;
        this.$store
        .dispatch("postClosingUM", {
          auth: this.getAuth,
          data, 
        })
        .then((res) => {
          this.displayMessageValue("successClose", res.message);
          //this.$router.go();
          this.modal1 = false;
          that.loadingmodalcloseUM = false;
          this.handleReload()
        })
        .catch((error) => {
          let response = Object.assign({}, error.response.data);
          if (response.status) {
            this.displayMessageValue("error-other", response.message);
          } else {
            //this.displayMessageValue("error-other", error);
            this.displayMessageValue("error", error.message);
          }
          that.loadingmodalcloseUM = false;
        });
      });
    },
    handleSave() {},
    handleClosePS(params) {
      console.log(params);
      this.confirmMessageValue("confirm-close", params, null);
    },
    closetrans(item) {
      // const data = {
      //   id_financing: item.id_financing,
      //   tlc: this.getAuth.username,
      // };
      this.postData.append("id_financing", item.id_financing);
      this.postData.append("tlc", this.getAuth.username);
      const data = this.postData;
      this.$store
        .dispatch("closePS", {
          auth: this.getAuth,
          data,
        })
        .then((res) => {
          this.displayMessageValue("successClose", res.message);
          //this.$router.go();
        })
        .catch((error) => {
          let response = Object.assign({}, error.response.data);
          if (response.status) {
            this.displayMessageValue("error-other", response.message);
          } else {
            //this.displayMessageValue("error-other", error);
            this.displayMessageValue("error", error.message);
          }
        });
    },
    handleLink(jenis, id_) {
      let manifest = "";
      if (jenis == "UMPP") {
        manifest = "UmppManifest";
      } else if (jenis == "UMPD") {
        manifest = "umpd_manifest";
      } 

      const route = this.$router.resolve({
        name: manifest,
        params: { id: id_ },
      });
      window.open(route.href, "_blank");
    },
    handleRemove(file){
      const index = this.DataClosing.pushFile.indexOf(file);
      const newFileList = this.DataClosing.pushFile.slice();
      newFileList.splice(index, 1);
      this.DataClosing.pushFile = newFileList;
      this.DataClosing.attachment = newFileList;
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.DataClosing.loadingadd = false;
        this.DataClosing.pushFile.push(file);
        this.doc_attachment.push({
          name: this.DataClosing.doc_name,
          file: this.DataClosing.pushFile,
        });
        return false;
      }
    },
    handlemodalClose(){
      this.modal1 = false;
    },
    changeActioncheck(data){
      // let indexD = _.findIndex(this.needProcess, (e) => {
      //     return e.id_um == data.id_um;
      // }, 0);
      // this.needProcess[indexD].cek = (data.cek=="0" ? "1" : "0");

      let indexE = _.findIndex(this.needProcess_origin, (e) => {
          return e.id_um == data.id_um;
      }, 0);
      this.needProcess_origin[indexE].cek = (data.cek=="0" ? "1" : "0");
      this.needProcess_origin = this.ArrshortMultiCol(this.needProcess_origin, {
        cek: "desc",
        date: "asc",
      });
    },
    handlesuccessClose(){
      this.handleReload();
    },
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid darken(white, 10);
  &-header {
    height: 50px;
    background: darken(white, 2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
    font-size: 1rem;
    font-weight: 500;
    color: @color-secondary;
    border-bottom: 1px dashed darken(white, 10);
    padding: @padding;
  }
  &-body {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

.bordered {
  border: 1px solid darken(white, 10);
}

.custom-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.list-item {
  display: flex;
  align-items: flex-start;
}
</style>

<style lang="less">
.custom-tabs {
  .ant {
    &-tabs-bar {
      margin-bottom: 0;
    }
    &-tabs-content {
      flex: 1;
    }
  }
}
</style>
//
